import { Button, Card, Title } from "@mantine/core";
import { useIntl } from "react-intl";
import { Navigate, useParams } from "react-router-dom";

export const CampaignScreen = () => {
  const intl = useIntl();

  return (
    <Card>
      <Card withBorder>
        <div style={{ float: "right" }}>
          <Button
            onClick={() => (window.location.href = "/admin-campaigns/new")}
            style={{ backgroundColor: "dodgerblue" }}
          >
            {intl.formatMessage({ id: "new" })}
          </Button>
        </div>
        <Title order={3}>{intl.formatMessage({ id: "campaigns" })}</Title>
      </Card>
    </Card>
  );
};

export const ManageCampaign = () => {
  const { id } = useParams();
  if (!id || id === "new") {
    return <Navigate to="/admin-imports" replace />;
  }
  return <Navigate to={`/admin-imports?pid=${encodeURIComponent(id)}`} replace />;
};
